import { TranslationsType } from "@/app/translations/Translations";

export const T_Footer: TranslationsType = {};
